import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import ssoHandler from "../ssoHandler";
import env from "../../config";

const wrapperStyles = {
  position: "relative",
  width: "100%",
  height: "100vh",
};

const iframeStyles = {
  width: "100%",
  height: "100%",
  border: "none",
  display: "block",
};

const AppIframe = () => {
  const { SSO, checkSSO } = ssoHandler();
  const [ssodata, setssodata] = useState({});
  const [loader, setloader] = useState(true);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    checkSSO();
  }, []);

  useEffect(() => {
    if (SSO != "" && SSO != undefined) {
      var data = JSON.parse(SSO);
      setssodata(data);
      setloader(false);
    }
  }, [SSO]);

  return (
    <div style={wrapperStyles}>
      <style>{`
        .ai-state {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 14px;
          background: #fafafa;
          padding: 24px;
          text-align: center;
          z-index: 2;
          transition: opacity .3s ease;
        }
        .ai-state.hidden {
          opacity: 0;
          pointer-events: none;
        }
        .ai-state-icon {
          width: 56px;
          height: 56px;
          border-radius: 14px;
          background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
          color: #2563eb;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          box-shadow: inset 0 0 0 1px rgba(29,78,216,.12);
        }
        .ai-state-icon.danger {
          background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
          color: #dc2626;
          box-shadow: inset 0 0 0 1px rgba(220,38,38,.12);
        }
        .ai-spinner {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          border: 3px solid #e2e8f0;
          border-top-color: #2563eb;
          animation: ai-spin .8s linear infinite;
        }
        @keyframes ai-spin { to { transform: rotate(360deg); } }
        .ai-state-title {
          font-size: 14px;
          font-weight: 600;
          color: #0f172a;
        }
        .ai-state-hint {
          font-size: 12.5px;
          color: #64748b;
          max-width: 340px;
        }
      `}</style>

      {loader ? (
        <div className="ai-state">
          <div className="ai-state-icon">
            <Icon icon="solar:shield-keyhole-bold-duotone" />
          </div>
          <div className="ai-spinner" />
          <div>
            <div className="ai-state-title">Authenticating…</div>
            <div className="ai-state-hint">Verifying your session</div>
          </div>
        </div>
      ) : ssodata.activeLocation ? (
        <div className="ai-state">
          <div className="ai-state-icon danger">
            <Icon icon="solar:lock-keyhole-bold-duotone" />
          </div>
          <div>
            <div className="ai-state-title">No access to this page</div>
            <div className="ai-state-hint">
              You don't have permission to view this page. Please contact your
              administrator if you think this is a mistake.
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className={`ai-state ${iframeLoaded ? "hidden" : ""}`}>
            <div className="ai-state-icon">
              <Icon icon="solar:widget-2-bold-duotone" />
            </div>
            <div className="ai-spinner" />
            <div>
              <div className="ai-state-title">Loading dashboard…</div>
              <div className="ai-state-hint">This usually takes a moment</div>
            </div>
          </div>
          <iframe
            style={iframeStyles}
            src={`${env.APP_URL}/${ssodata.companyId}/dashboard`}
            onLoad={() => setIframeLoaded(true)}
          ></iframe>
        </>
      )}
    </div>
  );
};

export default AppIframe;
